import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const editDetailedSummaryExpensesModalSchema = yupResolver(
  yup.object({
    accountDescription: yup.string().required('Descrição da conta é obrigatória'),
    accountCode: yup.string().required('Número da conta é obrigatório'),
    otherExpensesAmount: yup.string().required('Valor outras despesas é obrigatório'),
    observations: yup.string().required('Observações é obrigatória')
  })
)
